<template>
  <div>
    <h1 class="title">Parlaci del tuo {{ dogPosition }}</h1>

    <form class="form max-w-xs mx-auto" @submit.prevent>
      <div class="form-group">
        <label class="form-label" for="dog_name">Come si chiama?</label>
        <input
          v-model="$v.dog.name.$model"
          type="text"
          placeholder="Inserisci il nome del cane"
          class="form-control"
          id="dog_name"
        />
        <div v-if="!$v.dog.name.alpha" class="error">
          utilizzare solo lettere per il nome
        </div>
        <div v-else-if="$v.dog.name.$error" class="error">campo obbligatorio</div>
      </div>

      <div class="form-group">
        <label class="form-label">Di che razza è {{ dogData.name | capitalize }}?</label>
        <!-- <select class="form-control" v-model.number="$v.dog.breedId.$model">
          <option :value="null" disabled>Seleziona la razza</option>
          <option
            v-for="breed in breeds"
            v-bind:value="breed.id"
            :key="breed.id"
          >
            {{ breed.name }}
          </option>
        </select> -->

        <v-select
          class=""
          label="name"
          v-model.number="$v.dog.breedId.$model"
          :reduce="(breed) => breed.id"
          :options="breeds"
        ></v-select>

        <div v-if="$v.dog.breedId.$error" class="error">campo obbligatorio</div>
      </div>

      <div class="form-group">
        <label class="form-label">Il tuo pelosone ha più di 11 mesi?</label>
        <div class="switch-container" :class="[dog.adult == null ? 'switch-empty' : '']">
          <label
            for="adult_yes"
            class="switch-option"
            :class="[dog.adult == 1 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.adult.$model"
              class="hidden"
              type="radio"
              id="adult_yes"
              value="1"
            />
            <span>Sì</span></label
          >
          <label
            for="adult_no"
            class="switch-option"
            :class="[dog.adult == 0 ? 'active-option' : 'inactive-option']"
          >
            <input
              v-model.number="$v.dog.adult.$model"
              class="hidden"
              type="radio"
              id="adult_no"
              value="0"
            />
            <span>No</span></label
          >
        </div>
        <div v-if="$v.dog.adult.$error" class="error">campo obbligatorio</div>
      </div>

      <div v-if="showHowManyMonths" class="form-group">
        <label class="form-label" for="months">Quanti mesi ha?</label>
        <input
          v-model.number="$v.dog.months.$model"
          type="number"
          placeholder="Indica i mesi"
          min="2"
          max="11"
          class="form-control"
          id="months"
        />
        <div v-if="$v.dog.months.$error && !$v.dog.months.required" class="error">
          campo obbligatorio
        </div>
        <div v-if="$v.dog.months.$error && !$v.dog.months.minValue" class="error">
          Le pappe Real Bowl sono ideali dopo i 60 giorni di vita del tuo cucciolo. Per
          maggiore info
          <a :href="contactURL" target="_blank">contattaci</a>.
        </div>
        <div v-if="$v.dog.months.$error && !$v.dog.months.maxValue" class="error">
          inserire un valore compreso tra 2 e 11 mesi
        </div>
        <div class="additional-info">
          Non ti preoccupare se non ricordi il mese esatto, ci serve un'indicazione di
          massima per calibrare al meglio la sua porzione di cibo fresco
        </div>
      </div>

      <div v-if="dog.adult != null">
        <div class="form-group">
          <label class="form-label" for="dog_weight">{{ weightQuestion }}</label>
          <div class="flex items-end">
            <input
              v-model.number="$v.dog.weight.$model"
              type="number"
              min="1"
              placeholder="Inserisci il peso"
              class="form-control"
              id="dog_weight"
            />&nbsp;kg
          </div>
          <div v-if="$v.dog.weight.$error && !$v.dog.weight.required" class="error">
            campo obbligatorio
          </div>
          <div v-else-if="$v.dog.weight.$error && !$v.dog.weight.minValue" class="error">
            inserire un valore uguale o superiore a 1 kg
          </div>
        </div>
        <div v-if="dog.adult != 1" class="additional-info">
          Conoscendo la stazza <u>dei suoi genitori</u> riusciremo a stimare il suo
          fabbisogno calorico durante la crescita; tuttavia è importante tenere osservato
          il tuo cucciolo ed eventualmente aggiustare il calcolo in base al suo sviluppo
          fisico.
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, requiredIf, minValue, maxValue } from "vuelidate/lib/validators";
import { customValidators } from "../constants.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Object,
      required: true,
    },
  },
  components: {
    vSelect,
  },
  data() {
    return {
      showMixedBreeds: false,
      today: new Date(),
      dog: {
        birthDate: this.dogData.birthDate,
        name: this.dogData.name,
        breedId: this.dogData.breedId,
        months: this.dogData.months,
        adult: this.dogData.adult,
        weight: this.dogData.weight,
      },
      breeds: [],
      contactURL: this.$hostname + "/contatti",
    };
  },
  watch: {
    "dog.adult": function (value) {
      if (value == 1) {
        this.dog.months = null;
        this.dog.birthDate = "";
      }
    },
    "wizardData.indexDog": function () {
      this.dog.name = this.dogData.name;
      this.dog.breedId = this.dogData.breedId;
      this.dog.months = this.dogData.months;
      this.dog.birthDate = this.dogData.birthDate;
      this.dog.adult = this.dogData.adult;
      this.dog.weight = this.dogData.weight;
      this.$v.$reset();
    },
  },
  validations: {
    dog: {
      name: {
        required,
        alpha: customValidators.alpha,
      },
      breedId: {
        required,
      },
      months: {
        required: requiredIf(function () {
          return this.showHowManyMonths;
        }),
        minValue: minValue(2),
        maxValue: maxValue(11),
      },
      adult: {
        required,
      },
      weight: {
        required,
        minValue: minValue(1),
      },
    },
  },
  computed: {
    weightQuestion: function () {
      let question = "Quanto pesa";
      if (this.dog.adult != 1) {
        question += " indicativamente il suo papà";
      }
      return question.concat("?");
    },
    showHowManyMonths: function () {
      return this.dog.adult == 0;
    },
    dogPosition() {
      let str = "";
      if (this.wizardData.numberOfDogs > 1) {
        const ordinalNumbers = [
          "primo",
          "secondo",
          "terzo",
          "quarto",
          "quinto",
          "sesto",
          "settimo",
          "ottavo",
          "nono",
          "decimo",
        ];
        str = ordinalNumbers[this.wizardData.indexDog] + " ";
      }
      return str.concat("cane");
    },
  },
  methods: {
    setBirthDate() {
      let birthDate = "";
      if (this.dog.months) {
        let diffMonth = this.today.getMonth() + 1 - this.dog.months;
        if (diffMonth <= 0) {
          birthDate =
            this.today.getFullYear() -
            1 +
            "-" +
            ("00" + (12 + diffMonth)).slice(-2) +
            "-01";
        } else {
          birthDate =
            this.today.getFullYear() + "-" + ("00" + diffMonth).slice(-2) + "-01";
        }
      }
      this.dog.birthDate = birthDate;
    },
    getBreeds() {
      this.breeds = this.listData.breeds;
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        this.setBirthDate();
        if (!this.$v.$invalid) {
          resolve({
            dog: {
              name: this.dog.name,
              breedId: this.dog.breedId,
              months: this.dog.months,
              adult: this.dog.adult,
              weight: this.dog.weight,
              birthDate: this.dog.birthDate,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
  },
  created() {
    this.getBreeds();
  },
  activated() {
    this.getBreeds();
    this.dog.name = this.dogData.name;
    this.dog.breedId = this.dogData.breedId;
    this.dog.months = this.dogData.months;
    this.dog.adult = this.dogData.adult;
    this.dog.weight = this.dogData.weight;
    this.$v.$reset();
  },
};
</script>
<style></style>
